import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AccessibilityService, AccessibilityConfig } from '../../../services/accessibility.service';

@Component({
  selector: 'app-accessibility-modal',
  templateUrl: './accessibility-modal.component.html',
  styleUrls: ['./accessibility-modal.component.scss']
})
export class AccessibilityModalComponent {
  @Input() isVisible: boolean = false;
  @Output() close = new EventEmitter<void>();

  public configuracionActual: AccessibilityConfig;
  public opcionesFuente = [
    { value: 'small', label: 'Pequeño', sample: 'Texto pequeño' },
    { value: 'normal', label: 'Normal', sample: 'Texto normal' },
    { value: 'large', label: 'Grande', sample: 'Texto grande' },
    { value: 'extra-large', label: 'Extra grande', sample: 'Texto extra grande' }
  ];

  constructor(private accessibilityService: AccessibilityService) {
    this.configuracionActual = this.accessibilityService.obtenerConfiguracionActual();
  }

  public CambiarTamanioFuente(fontSize: string): void {
    this.configuracionActual.fontSize = fontSize as any;
    this.accessibilityService.actualizarConfiguracion({ fontSize: fontSize as any });
  }

  public RestablecerPorDefecto(): void {
    this.accessibilityService.restablecerPorDefecto();
    this.configuracionActual = this.accessibilityService.obtenerConfiguracionActual();
  }

  public Cerrar(): void {
    this.close.emit();
  }

  public Guardar(): void {
    this.close.emit();
  }

  public getSliderValue(fontSize: string): number {
    return this.opcionesFuente.findIndex(f => f.value === fontSize);
  }

  public onSliderChange(sliderValue: number): void {
    const idx = Number(sliderValue);
    const opcion = this.opcionesFuente[idx];
    if (opcion) {
      this.CambiarTamanioFuente(opcion.value);
    }
  }

  public getSample(fontSize: string): string {
    const found = this.opcionesFuente.find(o => o.value === fontSize);
    return found ? found.sample : '';
  }
}
